// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","sm":"Logo_sm__KeJY7","lg":"Logo_lg__3bKIJ","xl":"Logo_xl__3wsz4"};